import { Box } from '@mui/material'
import { memo, PropsWithChildren } from 'react'
import { useStyles } from './homeLayoutStyles'

type MainContentLayoutProps = PropsWithChildren & {
    embedded?: boolean
}

const MainContentLayout = ({ children, embedded = false }: MainContentLayoutProps) => {
    const { classes, cx } = useStyles()

    return (
        <Box className={cx(classes.mainContentFrame, embedded && classes.mainContentFrameEmbedded)}>
            <Box className={classes.mainContentSurface}>{children}</Box>
        </Box>
    )
}

export default memo(MainContentLayout)
